'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
// import TechnologyFaq from "@/components/technologies/technology-faq"
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
// import AndroidFAQ from "@/components/faqs/android-faq"
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import HybridServices from '@/components/technologies/hybrid-services';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Our hybrid app development services provide power-packed Native app functionalities across web and mobile solutions at cost-effective rates."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'hybrid-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Hybrid App Development
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Hybrid App Development" />
            <ContetVideoSection title="Hybrid App Development Company that Builds Powerful Native-looking Apps">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        With our hybrid mobile app development services, we build future-ready business apps at cost-effective
                        rates. You can rule the geographical market with the most minimum investment.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Being one of the top hybrid mobile app development company, Moweb excel in building powerful and
                        interactive web and mobile apps. Our hybrid app developers use the blend of cutting-edge frameworks like
                        Ionic, Titanium, React Native, Node.JS, Flutter, PhoneGap, and more to deliver super-flawless apps.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        With hybrid mobile development, we package your application in the cloud which removes the pain of
                        compiling a phone in the cloud. And, we make your apps ready to launch without maintaining native SDKs.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Establish a strong presence over multiple devices on-budget with hybrid mobile application development.
                    </p>
                </>
            </ContetVideoSection>
            <HybridServices title="Hand-Picked Hybrid App Developers with Best-In-Class Cross-Platform Trails"></HybridServices>
            <HireProcess
                bg="bg-hybridapp"
                pageTitle="Hire Custom Hybrid App Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Hybrid Apps."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for Hybrid App Development?" />
            <ModelsOfWorking
                title="Engagement models to hire the best Hybrid App Developers"
                desc="Select from different engagement models to hire Hybrid App Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            {/* <TechnologyFaq
        title="FAQs On Android Development Services"
        bg="bg-hybridapp"
      >
        <AndroidFAQ />
      </TechnologyFaq> */}
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
